export enum CONFIGURABLE_PAGE_IDS {
  COMPANY_CREATION_DASHBOARD = 'clban6j64000208l52d8wfvkd',
  SELF_EMPLOYMENT_STEPS_AFTER_REGISTRATION = 'clo5r5awj000008mg3p3i6to1',
  SELF_EMPLOYMENT_PRICING_PAGE = 'clnlsj720000208l99nzr9nve',
  SELF_EMPLOYMENT_SERVICE_CARDS_PAGE = 'cltyf1030000008k0fftndalu',
  SINGLE_PERSON_STEPS_AFTER_REGISTRATION = 'clo4f9ptv000108jr49959vhd',
  SINGLE_PERSON_PRICING_PAGE = 'cmdd6b5bs00h607l790yq124i',
  SINGLE_PERSON_SERVICE_CARDS_PAGE = 'cmdd6bgfu00h707l797ege5ao',
}
